import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

export class TableHeadSortingCell extends React.Component {
  static propTypes = {
    sortingByColumn: PropTypes.bool.isRequired,
    sortDirection: PropTypes.oneOf(['ASC', 'DESC']).isRequired,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const iconClasses = classNames('fa u-floatRight', {
      'fa-sort': !this.props.sortingByColumn,
      'fa-sort-desc':
        this.props.sortingByColumn && this.props.sortDirection === 'DESC',
      'fa-sort-asc':
        this.props.sortingByColumn && this.props.sortDirection === 'ASC',
    });

    return (
      <th
        className={'u-clickable ' + this.props.className}
        style={this.props.style}
        onClick={this.props.onClick}
      >
        <i className={iconClasses} />
        {this.props.children}
      </th>
    );
  }
}
